import request from '@/api/axios';


// 示例：
export function getCountryList() {
    return request({
      url: '/api/product/v1/country/list',
      method: 'get'
    });
  }


export function checkCardIccid(iccid) {
    return request({
        url: `/api/customer/v1/checkCardIccid/${iccid}`,
        method: 'get'
    });
}
